import { IOffer } from '../../../../types/offer';
import { getAgentBonusPrice } from '../getAgentBonusPrice';
import { getDepositPrice } from './getDepositPrice';
import { getFeePrice } from './getFeePrice';
import { getLeasePeriod } from './getLeasePeriod';
import { getUtilitiesTermsPrice } from './getUtilitiesTermsPrice';

export function getRentPriceInfo(offer: IOffer, isAgent: boolean): string | undefined {
  const infoParts = [
    getLeasePeriod(offer),
    getUtilitiesTermsPrice(offer),
    getFeePrice(offer, isAgent),
    getDepositPrice(offer),
    getAgentBonusPrice(offer, isAgent),
  ].filter(Boolean);

  if (infoParts.length > 0) {
    const res = infoParts.join(', ');

    return `${res[0].toUpperCase()}${res.slice(1)}`;
  }

  return undefined;
}
